import styled from "styled-components";



const ProfileImageStyled = styled.span`
    display: flex;
    border-radius: 50%;
    border: none;
    width: 30px;
    height: 30px;
    overflow: hidden;
    button{
        border: none;
        cursor: pointer;
        & img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            cursor: pointer;
        }
    }

    @media only screen and (min-width: 992px) {
        width: 40px;
        height: 40px;
        
    }    
`;


export default ProfileImageStyled;